


import React from 'react';

import ReactDOM from 'react-dom';
import { Dialog } from 'element-react';
import { Button,Drawer } from '@jd/find-react';
 

import KeeVue from '../base/KeeVue.js'
import FeasComponents from './FeasComponents.js'
import FsResizers from './FsResizers.js'
import FeasPage from './FeasPage.js'
import FsView from './FsView.js'
import $ from 'jquery';



export default class FsWinManager extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				id: this.getRandString(),
				topWin: {
				},
				rightMenu: {
					active: false,
					url: "",
					data: {},
					showContent: false,
				},
				rightDetail: {
					active: false,
					url: "",
					data: {},
					showContent: false,
					showContent2:false,
				},
				bottomDetail: {
					active: false,
					url: '',
					data: null,
				},
				dialogs: [],
				seq: 1,
				startX: 0,
				startY: 0,
				left: 0,
				top: 0,
				poldX: 0,
				poldY: 0,
				isMouseDown: false,
				isAutoClose: false,
				style: {
					left: 0,
					top: 0,
					width: '400px',
					height: '600px'
				},
				startPoint: {
					isMouseDown: false,
					x: 0,
					y: 0,
					left: 0,
					top: 0,
				},
				
			};

}

componentDidMount(){
			var that = this;
			this.registComponent();
			this.onEvent("win.open.react", this.onOpen);
			this.onEvent("body.click", this.onBodyClick);
			// $("body").on("mousemove", this.onTitleMousemove);
			$("body").on("mouseup", function() {
				that.state.startPoint.isMouseDown = false;
				$("body").off("mousemove", this.onTitleMousemove);
			});
			
			this.onEvent("closeBottom",()=>{
				this.state.bottomDetail.active=false;
				this.refresh();
			})
			 

		}

			beforeEnter=()=>{
				console.log("beforenter");
				this.state.rightDetail.showContent2=false;
			}
			enter=()=>{
				this.state.rightDetail.showContent2=false;
				console.log("enter");
			}
			afterEnter=()=>{
				this.state.rightDetail.showContent2=true;
				console.log("afterEnter");
				setTimeout( ()=>{
					this.$emit("keeResize");
				},200);
			}
			beforeLeave=()=>{
			}
			leave=()=>{
			}
			afterLeave=()=>{
			}
			onCommand=(cmdName, item, po, thisForm, parentForm)=> {
				if(cmdName === "cancel" || cmdName === "close") {
					if(this.state.dialogs.length > 0) {
						$("#dlg" + this.state.dialogs[this.state.dialogs.length - 1].id + " .el-dialog__header").off('mousedown');
						$("#dlg" + this.state.dialogs[this.state.dialogs.length - 1].id).off('mousemove');
						$("#dlg" + this.state.dialogs[this.state.dialogs.length - 1].id).off('mouseup');
						this.state.dialogs.remove(this.state.dialogs[this.state.dialogs.length - 1]);
					}
				}
				this.$emit("command", cmdName, item, po, thisForm, parentForm);
			}
			onOpen=(obj)=> {
				
				// if(window.showReact===false)
				// {
				// 		  return "";
				// }
		 
				var that = this;
		 

				if(obj.target === "menu") {
					if(obj.data.event !== null) {
						var event = obj.data.event;
						var that = this;
						var left = event.clientX;
						var top = event.clientY;
						var totalWidth = $("body").width();
						var totalHeight = document.documentElement.clientHeight;
						if((totalWidth - left - 30) < 310) {
							this.state.style.left = (totalWidth - 310) + "px";
						} else {
							this.state.style.left = left + "px";
						}
						if(totalHeight - top < 610) {
							this.state.style.top = (totalHeight - 610) + "px";
						} else {
							this.state.style.top = top + "px";
						}
						this.state.style.width = "400px";
						this.state.style.height = "600px";
					}
					that.isAutoClose = true;
					if(obj.data.isAutoClose !== null) {
						that.isAutoClose = obj.data.isAutoClose;
					}
					
					//alert("that.isAutoClose:"+that.isAutoClose)
					if(this.rightMenu.active === true) {
						that.rightMenu.url = obj.url;
						that.rightMenu.data = obj.data;
					} else {
						this.rightMenu.active = true;
						this.rightMenu.showContent = false;
						that.rightMenu.data = obj.data;
						that.rightMenu.url = obj.url;
						that.rightMenu.appCode=obj.appCode;

							that.rightMenu.showContent = true;

					}
				}
				if(obj.target === 'right') {
					that.isAutoClose = false;
					if(obj.data.isAutoClose !== null) {
						that.isAutoClose = obj.data.isAutoClose;
					}
					if(this.state.rightDetail.active === true) {
						this.state.rightDetail.url = obj.url;
						this.state.rightDetail.data = obj.data;
						this.state.rightDetail.appCode=obj.appCode;
					} else {
						this.state.rightDetail.active = true;
						this.state.rightDetail.showContent = false;
						this.state.rightDetail.data = obj.data;
						this.state.rightDetail.url = obj.url;
						this.state.rightDetail.appCode=obj.appCode;
						setTimeout(function() {
							that.state.rightDetail.showContent = true;
						}, 200);
					}
				}
				if(obj.target === 'bottom') {
					if(this.state.bottomDetail.active === true) {
						that.state.bottomDetail.url = obj.url;
						that.state.bottomDetail.data = obj.data;
					} else {
						this.state.bottomDetail.active = true;
						this.state.bottomDetail.showContent = false;
						that.state.bottomDetail.data = obj.data;
						that.state.bottomDetail.appCode=obj.appCode;
						that.state.bottomDetail.showContent = true;
						that.state.bottomDetail.url = obj.url;
						
						 
					}
					this.refresh();
				}
				if(obj.target === "dialog") {
					
					var dlgId = this.getRandString();
					
					 
					this.state.dialogs.push({
						id: dlgId,
						active: true,
						url: obj.url,
						data: obj.data,
						width:obj.width,
						appCode:obj.appCode,
					})
					setTimeout(function() {
						$("#dlg" + dlgId + " .el-dialog__header").on('mousedown', function(e) {
							that.mouseDown(e, dlgId)
						});
						$("#dlg" + dlgId).on('mousemove', function(e) {
							that.mouseMove(e, dlgId)
						});
						$("#dlg" + dlgId).on('mouseup', that.mouseUp);
					}, 200);
				}
				this.refresh(); 

			}
			onTitleMousemove=(event)=> {
				
				console.log("mousemovelllll");
				var that = this;
				if(this.state.startPoint.isMouseDown === true) {
					var left = this.state.startPoint.left + (event.clientX - this.state.startPoint.x);
					var top = this.state.startPoint.top + (event.clientY - this.state.startPoint.y);
					var totalWidth = $("body").width();
					var totalHeight = document.documentElement.clientHeight;
					if((totalWidth - left) < 310) {
						this.state.style.left = (totalWidth - 310) + "px";
					} else {
						this.state.style.left = (left) + "px";
					}
					if(totalHeight - top < 610) {
						this.state.style.top = (totalHeight - 610) + "px";
					} else {
						this.state.style.top = (top) + "px";
					}

					this.refresh();

				}
			}
			onTitleMousedown=(event)=> {
				this.state.startPoint.isMouseDown = true;
				console.log("启动")
				$("body").on("mousemove", this.onTitleMousemove);
				this.state.startPoint.x = event.clientX;
				this.state.startPoint.y = event.clientY;
				this.state.startPoint.left = parseInt(this.state.style.left.replace("px", ""));
				this.state.startPoint.top = parseInt(this.state.style.top.replace("px", ""));
				this.refresh();
			}
			mouseDown=(event, dlgId)=> {
				console.log("mouseDown");
				this.startX = event.clientX;
				this.startY = event.clientY;
				this.state.isMouseDown = true;
				this.poldX = $("#dlg" + dlgId + " .el-dialog").css("left");
				this.poldY = $("#dlg" + dlgId + " .el-dialog").css("top");
				console.log(this.poldX + " , " + this.poldY)
				this.refresh();
			}
			mouseMove=(e, dlgId)=> {
				if(this.state.isMouseDown === true) {
					if(typeof this.top === "string") {
						var windowHeight = window.innerHeight;
						var windowWidth = window.innerWidth;
						this.top = parseInt(windowHeight * 0.15);
						this.left = parseInt(windowHeight * 0.25);
					}
					this.left = parseInt(this.poldX.replace("px", "")) + (e.clientX - this.startX);
					this.top = parseInt(this.poldY.replace("px", "")) + (e.clientY - this.startY);
					$("#dlg" + dlgId + " .el-dialog").css("left", this.left);
					$("#dlg" + dlgId + " .el-dialog").css("top", this.top);

					this.refresh();
				}
			}
			mouseUp=(e)=> {
				this.state.isMouseDown = false;
			}
			closeRight=()=> {
				$("video").each(function(){
    					this.pause();
  					});
				this.state.rightDetail.url = "M::jdccBlankPage";
				this.state.rightDetail.active = false;
				this.refresh();
			}
			closeDlg=(obj)=> {
				
				 
				$("#dlg" + obj.id + " .el-dialog__header").off('mousedown');
				$("#dlg" + obj.id).off('mousemove');
				$("#dlg" + obj.id).off('mouseup');
				this.state.dialogs.remove(obj);

				this.refresh();
			}
			onSelfClick=(obj)=> {
				console.log("拦截click请求")
			}
			closeBottom=()=>{
				 
				this.state.bottomDetail.active=false;
				this.refresh();
			}
			onBodyClick=(event)=> {
				if($(event.target).hasClass("edui-default") === true || $(event.target).parents(".edui-default").length > 0) {
					return;
				}
				if(($(event.target).parents(".fancybox-overlay").length > 0) ||
					($(event.target).parents(".fancybox-lock").length > 0)) {
					return;
				}
				if($(event.target).hasClass("fancybox-close") === true) {
					return;
				}
				if($(event.target).parents(".el-message-box__wrapper").length > 0) {
					return;
				}
				console.log("this.state.rightDetail.data.isAutoClose="+this.state.rightDetail.data.isAutoClose);
				if(this.state.rightDetail.active !== false && this.state.rightDetail.data && this.state.rightDetail.data.isAutoClose !== false) {
					$("video").each(function(){
    					this.pause();
  					});
					this.state.rightDetail.url = "M::jdccBlankPage";
					this.state.rightDetail.active = false;
				}
				if(this.rightMenu.active !== false && this.isAutoClose === true) {
					this.rightMenu.url = "M::jdccBlankPage";
					this.rightMenu.active = false;
				}
				this.state.bottomDetail.active = false;
			}
			onChanged=(item)=> {
				  
				$("#dlg" + item.id + " .el-dialog__header").off('mousedown');
				$("#dlg" + item.id).off('mousemove');
				$("#dlg" + item.id).off('mouseup');
				this.state.dialogs.remove(item); 
				this.refresh();
			}
			cancel=(ret)=> {
				$("video").each(function(){
    					this.pause();
  					});
				this.state.rightDetail.active = false;
				this.$emit("cancel", ret);
				this.refresh();
			}
			onCommand=(cmdName, item, po, thisForm, parentForm)=> {
				
				 
				if(cmdName === "cancel") {
					$("#dlg" + item.id + " .el-dialog__header").off('mousedown');
					$("#dlg" + item.id).off('mousemove');
					$("#dlg" + item.id).off('mouseup');
					this.state.dialogs.remove(item);
					 
				}
				if(cmdName === "close") {
					$("#dlg" + item.id + " .el-dialog__header").off('mousedown');
					$("#dlg" + item.id).off('mousemove');
					$("#dlg" + item.id).off('mouseup');
					this.state.dialogs.remove(item);
					 
				}
				this.$emit("command", cmdName, item, po, thisForm, parentForm);
				this.refresh();
			}
			showWindow=(args)=> {}
			openDialog=(config)=> {}
			openComponent=(url, activeParams, type)=> {}
			close=()=> {
				this.$emit("close");
			}

  render(){
	  
	setTimeout(()=>{
		this.state.dialogs.map((item,index)=>{
			if(item.active)
			{
				if(item.data&&item.data.width)
				{
					$("#dlg" + item.id + " .el-dialog").css("width",item.data.width);
				} 
				$("#dlg" + item.id + "").css("display","block");
			}
			});
	},50);
	  
		
	  
	  
  return(

<div style={{width:' 100%',height:' 100%'}} >

    
	
			<Drawer
	           
	          placement={'right'}
	          closable={true}
			  zIndex={1000}
			  title="详情"
	          onClose={()=>{this.state.rightDetail.active=false;this.refresh();}}
	          visible={this.state.rightDetail.active===true}
	          key={'right'}
			  width={'60%'}>
			{
				this.state.rightDetail.active===true&& 
				 
				        <FsView  
						url={this.state.rightDetail.url} 
						appCode={this.state.rightDetail.appCode} 
						owner={this.state.rightDetail} 
						parameters={this.state.rightDetail.data} 
						onClose={this.closeRight} 
						oncancel={this.closeRight} 
						keepAlive={true} debug={this.props.debug} >
				        </FsView>
				   
				 
			}
	          
	        </Drawer>
			
	
    <div   >
	{ 
		
		<Drawer
		          title={this.state.bottomDetail.data?this.state.bottomDetail.data.title:''}
		          placement={'bottom'}
		          closable={true}
		          onClose={()=>{this.state.bottomDetail.active=false;this.refresh();}}
		          visible={this.state.bottomDetail.active===true}
		          key={'bottom'}
				  height={this.state.bottomDetail.data&&this.state.bottomDetail.data.height?this.state.bottomDetail.data.height:'90%'}
		        >
				{this.state.bottomDetail.active&&<div className={`jdcc-bottom-layer`} >
				    
				    <FsView url={this.state.bottomDetail.url} 
									    showVueMode={true}
										debug={false} 
										
									   appCode={this.state.bottomDetail.appCode} parameters={this.state.bottomDetail.data} keepAlive={this.state.true} debug={this.state.debug} >
				    </FsView>
				</div>}
		        </Drawer>
	}

    </div>
	{
		this.state.dialogs&&<div style={{width:' 100%',height:' 100%'}}   onClick={this.onSelfClick} >

		{
			this.state.dialogs.map((item,index)=>{
				return item.active?<div id={'dlg'+item.id} style={{"display":"none"}} className={item.data.className}  key={item.id+index} >
				  <Dialog title={item.data.title} size={item.data.size} width={item.data.width}
			top={item.data.top}

			visible={item.active}
			 closeOnClickModal={false}
			 closeOnPressEscape={false}
			 onClose={()=>this.closeDlg(item)}
			  onCancel={()=>this.closeDlg(item)}
			   >
                <FsView url={item.url} fromItem={item.id} parameters={item.data} po={item.data.po} appCode={item.appCode} keepAlive={true}
				 onchanged={()=>this.onChanged(item)}
				  onClose={()=>this.closeDlg(item)}
				  onCancel={()=>this.closeDlg(item)}
				  onCommand={()=> this.onCommand(item)}
				  debug={this.props.debug} >
                </FsView>
            </Dialog></div>
			:''
			})
		}


    </div>
	}
    {
		this.state.rightMenu&&this.state.rightMenu.active==true&&<div class={`kee-fs-right-menu`}  style={this.state.style } onClick={this.onSelfClick} >
        <div style={{position:' absolute',top:' 0',left:' 0',right:' 0',height:' 40px',padding:' 8px'}} >
            <div style={{'float':'right'}} >
                <i className={`fa fa-close`} onClick={this.rightMenu.active=false} style={{fontSize:' 24px',cursor:' pointer'}} >
                </i>
            </div>
            <div style={{fontSize:'16px ',lineHeight:'36px',paddingLeft:'3px',fontWeight:' bold',cursor:'move'}} onmousedown={this.onTitleMousedown} >

					{this.state.rightMenu.data.title}

            </div>
        </div>
		{
			this.state.rightMenu.showContent===true&& <FsView  url={this.state.rightMenu.url}
			po={this.state.rightMenu.data.po}
			appCode={this.state.rightMenu.appCode}
			owner={this.state.rightMenu}
			parameters={this.state.rightMenu.data}
			onClose={this.closeRight}
			onCancel={this.closeRight}
			keepAlive={this.state.true}
			debug={this.props.debug} >
			</FsView>
		}

    </div>
	}

</div>
  );}
 }


